import type { ChartConfig } from '@/shared/ui';

export const chartConfig = {
  desktop: {
    label: 'Desktop',
  },
} satisfies ChartConfig;
